import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../logo.png';
import '../App.css';
const Home = () => {

    
    return (
        <div className="container">
            {/* <div className='row mt-5 mb-3'>
                <div className='col col-md-2'>
                    <Link to='/'>
                        <img style={{ width: '15rem' }} src={logo} alt='osp logo' />
                    </Link>
                </div>
                <div className='col col-md-10' style={{ textAlign: 'center' }}><h1>Frequently Asked Questions</h1></div>
            </div> */}


            <div className="jumbotron jumbotron-fluid" style={{ backgroundColor: 'whitesmoke', border: '1px gray solid', marginTop:'3rem', padding: '3rem' }}>
                <div className="container">
                   <center> <h1>2021 Policies &amp; Information</h1></center>
                    

                   <Link to='/'> <button className='btn btn-block btn-dark btn-sm'><span style={{fontSize:'smaller'}}>Back to Homepage</span> </button></Link>
<hr style={{marginTop:'1rem',marginBottom:'2rem'}}/>

        <iframe height="600" width="800" src="https://docs.google.com/document/d/e/2PACX-1vSN_6x7_1LaIzOnhJFSEuJrE_TgeMWSAzDDe40T7CPLvHx6LvW93KbDuKVyFUuJZ_ut1zu2A31l3ni7/pub?embedded=true"></iframe>

        
        <hr style={{marginTop:'1rem',marginBottom:'2rem'}}/>

        
<Link to='/'> <button className='btn btn-block btn-dark btn-sm'><span style={{fontSize:'smaller'}}>Back to Homepage</span> </button></Link>
              
               </div>
            </div>
        </div>
    );
}

export default Home
